let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkCP2")).then(() => parcelRequire('jYkEH'));